import { getUserExperimentIdentifier } from '../../experiments/getUserExperimentIdentifier';
import { getHistory } from '../../routing/history';
import { earlyRequestClient } from '../earlyRequestClient';
import { getBulkTreatmentsRequestData } from './getBulkTreatmentsRequestData';
export const TREATMENTS_API_URL = '/treatments/v2/bulk-get';
export const TREATMENTS_EARLY_REQUEST_KEY = 'treatments-bulk-get';
const EXP_DISABLED_PARAM = 'exp-disabled';
export const makeBulkTreatmentsEarlyRequest = () => {
  const data = getBulkTreatmentsRequestData();
  const queryParams = new URLSearchParams(getHistory().location.search);
  const flowFromPath = getHistory().location.pathname.split('/')[1];
  const softwareSignupFlows = ['crm', 'marketing', 'sales', 'service', 'cms-free'];
  const isPostVerificationFlow = queryParams.get('token');
  const shouldPreventRequest = !data || data.length === 0 || queryParams.has(EXP_DISABLED_PARAM) || isPostVerificationFlow || !softwareSignupFlows.includes(flowFromPath);

  if (shouldPreventRequest) {
    return;
  }

  earlyRequestClient.post({
    apiUrl: `${TREATMENTS_API_URL}?ceid=${getUserExperimentIdentifier()}`,
    data,
    earlyRequestKey: TREATMENTS_EARLY_REQUEST_KEY
  });
};